export type TaskPageParams = "history" | "performance";
const ROUTES = {
  HOME: () => "/",
  FAQ: (type?: string) => `/faq${type ? `?type=${type}` : ""}`,
  TASK: {
    INDEX: (type?: TaskPageParams) => `/my-task${type ? `?type=${type}` : ""}`,
    DETAIL: (id: string) => `/my-task/${id}`,
  },
  DIGIPOS : {
    INDEX: () => `/import-digipos`,
  },
  ACCOUNT: {
    INDEX: (params?: string) => `/accounts${params ?? ""}`,
    DETAIL: (id: string) => `/accounts/${id}`,
  },
  PRIORITY: {
    INDEX: (params?: string) => `/accounts-priority${params ?? ""}`,
  },
  TERRITORY: {
    INDEX: (params?: string) => `/territories${params ?? ""}`,
  },
  BAK: {
    INDEX: (params?: string) => `/bak${params ?? ""}`,
  },
  VISIT: {
    INDEX: (params?: string) => `/visits${params ?? ""}`,
    DETAIL: (id: string) => `/visits/${id}`,
  },
  ACCOUNTS_LOCATION: {
    INDEX: (params?: string) => `/accounts-location${params ?? ""}`,
    DETAIL: (id: string) => `/accounts-location/${id}`,
  },
  CONTACT: {
    INDEX: (params?: string) => `/contacts${params ?? ""}`,
    DETAIL: (id: string) => `/contacts/${id}`,
  },
  USERS: {
    INDEX: (params?: string) => `/users${params ?? ""}`,
    DETAIL: (id: string) => `/users/${id}`,
  },
  ROLE: {
    INDEX: (params?: string) => `/roles${params ?? ""}`,
    DETAIL: (id: string) => `/roles/${id}`,
  },
  PERMISSION: {
    INDEX: (params?: string) => `/permissions${params ?? ""}`,
    DETAIL: (id: string) => `/permissions/${id}`,
  },
  CATEGORY: {
    INDEX: (params?: string) => `/categories${params ?? ""}`,
    DETAIL: (id: string) => `/categories/${id}`,
  },
  TYPE: {
    INDEX: (params?: string) => `/types${params ?? ""}`,
    DETAIL: (id: string) => `/types/${id}`,
  },
  FACULTY: {
    INDEX: (params?: string) => `/faculties${params ?? ""}`,
    DETAIL: (id: string) => `/faculties/${id}`,
  },
  DEALING: {
    INDEX: (params?: string) => `/registration-dealing${params ?? ""}`,
    DETAIL: (id: string) => `/registration-dealing/${id}`,
  },
  PRODUCT: {
    INDEX: (params?: string) => `/products${params ?? ""}`,
    DETAIL: (id: string) => `/products/${id}`,
  },
  OPPORTUNITY: {
    INDEX: (params?: string) => `/opportunities${params ?? ""}`,
    DETAIL: (id: string) => `/opportunities/${id}`,
  },
  ATTENDANCE: {
    PRESENCE: () => "/attendance/presence",
    HISTORY: () => "/attendance/history",
    HISTORY_DETAIL: (id: string) => `/attendance/history/${id}`,
  },
  SETTING: () => "/setting",
  NOTIFICATION: () => "/notifications",
  NEWS: () => "/news",
  DASHBOARD: (params?: string) => `/dashboard${params || ""}`,
  USER: {
    change_password: () => `/user/edit-profile`,
  },
  AUTH: {
    LOGIN: () => `/auth/signin`,
  },
};

export default ROUTES;
